import { render, staticRenderFns } from "./available-batch.vue?vue&type=template&id=04932959&"
import script from "./available-batch.vue?vue&type=script&lang=js&"
export * from "./available-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports